// Import all sponsor images
import bazarville from "../assets/sponsor-images/bazarville.png"
import bluelearn from '../assets/sponsor-images/bluelearn.png'
import blunt from '../assets/sponsor-images/blunt.png'
import campustimes from '../assets/sponsor-images/campustimes.png'
import finlatics from '../assets/sponsor-images/finlatics.png'
import givemycertificate from '../assets/sponsor-images/GIVEMYCERTIFICATE.png'
import internshala from '../assets/sponsor-images/internshala.png'
import interviewbuddy from '../assets/sponsor-images/interviewbuddy.png'
import markonow from '../assets/sponsor-images/markonow.png'
import noticebard from '../assets/sponsor-images/noticebard.png'
import notion from '../assets/sponsor-images/notion.png'
import startupnews from '../assets/sponsor-images/startupnews.png'
import startuptalky from '../assets/sponsor-images/startuptalky.png'
import stockedge from '../assets/sponsor-images/stockedge.png'
import stockgro from '../assets/sponsor-images/stockgro.png'
import toponepercent from '../assets/sponsor-images/toponepercent.png'
import travelyatri from '../assets/sponsor-images/travelyatri.png'
import unstop from '../assets/sponsor-images/unstop.png'
import vold from '../assets/sponsor-images/vold.png'
import yashahvi from '../assets/sponsor-images/yashahvi.png'

export const sponsorImages = {
    bazarville,
    bluelearn,
    blunt,
    campustimes,
    finlatics,
    givemycertificate,
    internshala,
    interviewbuddy,
    markonow,
    noticebard,
    notion,
    startupnews,
    startuptalky,
    stockedge,
    stockgro,
    toponepercent,
    travelyatri,
    unstop,
    vold,
    yashahvi
}